'use client';

import QueryMatchLanding from '@/components/QueryMatchLanding';

export default function AnsweringServiceForPlumbersPage() {
  return (
    <QueryMatchLanding
      pageName="Answering Service for Plumbers"
      analyticsContext="answering_service_plumbers"
      eyebrow="Answering service for plumbers"
      h1="What Plumbers Actually Get from a $200–$400/mo Answering Service"
      subhead="Most plans take messages. Greet is the AI plumbing virtual receptionist that answers, books jobs, and flags emergencies-at a flat monthly rate."
      bullets={[
        'Answers 24/7 including nights and weekends-no after-hours surcharge',
        'Books service calls into your calendar instead of leaving voicemail callbacks',
        'Triages burst pipes vs. routine leaks so you only get woken for real emergencies',
        'Flat-rate pricing vs. per-minute answering service overages',
      ]}
      industryLabel="Plumbers"
      industryHref="/plumbing"
      industryCtaLabel="See the full plumbing page"
      accent="blue"
    />
  );
}
